import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Table, Spin, Tag } from 'antd';
import { DownloadOutlined, LoadingOutlined } from '@ant-design/icons';
import IconNoData from '../../../../../assets/Images/icons/icon-no-data';
import TemplateDesignService from '../../../../../services/TemplateDesign.service';
import useNotify from '../../../../../context/Notification/useNotify';
import {
    htmlTermToStringEn,
    htmlTermToStringTh,
    htmlToStringEn,
    htmlToStringTh,
} from './HtmlToString';
import { convertBase64toBlob } from '../../../../../util/util';
import usePermission from '../../../../../hooks/usePermission';

const documentType = {
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    pdf: 'application/pdf',
};
const DownloadFile = ({
    templateDetail,
    templateDetailPublish,
    logo,
    logoPublish,
    templateType,
    masterTerm,
}) => {
    const { isAuditor } = usePermission();
    const { t, i18n } = useTranslation('consent');
    const lang = i18n?.language;
    const [docInfo, setDocInfo] = useState([]);
    const [loading_, setLoading_] = useState(false);
    const notify = useNotify();
    const [key, setKeys_] = useState();

    function decodeHtmlString(htmlString) {
        const parser = new DOMParser();
        const decodedString = parser.parseFromString(htmlString, 'text/html')
            .body.textContent;
        return decodedString;
    }

    useEffect(() => {
        if (templateDetail) {
            if (!templateDetail?.latestPublishedDate) {
                let date1 = templateDetail?.updateDate
                    ?.substring(0, 10)
                    .split('/');
                const updateDate = `${date1[2]}-${date1[1]}-${date1[0]}`;

                setDocInfo([
                    {
                        fileName:
                            lang === 'en'
                                ? `${decodeHtmlString(
                                      templateDetail?.templateNameEn
                                  )}_${updateDate}_TH`
                                : `${decodeHtmlString(
                                      templateDetail?.templateNameTh
                                  )}_${updateDate}_TH`,
                        templateKey: templateDetail?.templateKey,
                        lang: 'th', //"en", "th"
                        version: templateDetail?.version,
                        fileType: 'docx', //"docx", "pdf"
                        versionType: 'Latest Version', //"docx", "pdf"
                        logoId: templateDetail?.logoId,
                    },
                    {
                        fileName:
                            lang === 'en'
                                ? `${decodeHtmlString(
                                      templateDetail?.templateNameEn
                                  )}_${updateDate}_EN`
                                : `${decodeHtmlString(
                                      templateDetail?.templateNameTh
                                  )}_${updateDate}_EN`,
                        templateKey: templateDetail?.templateKey,
                        lang: 'en', //"en", "th"
                        version: templateDetail?.version,
                        fileType: 'docx', //"docx", "pdf"
                        versionType: 'Latest Version', //"docx", "pdf"
                        logoId: templateDetail?.logoId,
                    },
                    {
                        fileName:
                            lang === 'en'
                                ? `${decodeHtmlString(
                                      templateDetail?.templateNameEn
                                  )}_${updateDate}_TH`
                                : `${decodeHtmlString(
                                      templateDetail?.templateNameTh
                                  )}_${updateDate}_TH`,
                        templateKey: templateDetail?.templateKey,
                        lang: 'th', //"en", "th"
                        version: templateDetail?.version,
                        fileType: 'pdf', //"docx", "pdf"
                        versionType: 'Latest Version', //"docx", "pdf"
                        logoId: templateDetail?.logoId,
                    },
                    {
                        fileName:
                            lang === 'en'
                                ? `${decodeHtmlString(
                                      templateDetail?.templateNameEn
                                  )}_${updateDate}_EN`
                                : `${decodeHtmlString(
                                      templateDetail?.templateNameTh
                                  )}_${updateDate}_EN`,
                        templateKey: templateDetail?.templateKey,
                        lang: 'en', //"en", "th"
                        version: templateDetail?.version,
                        fileType: 'pdf', //"docx", "pdf"
                        versionType: 'Latest Version', //"docx", "pdf"
                        logoId: templateDetail?.logoId,
                    },
                ]);
            } else {
                let date1 = templateDetail?.updateDate
                    ?.substring(0, 10)
                    .split('/');
                const updateDate = `${date1[2]}-${date1[1]}-${date1[0]}`;

                let date2 = templateDetail?.latestPublishedDate
                    ?.substring(0, 10)
                    .split('/');
                const publishedDate = `${date2[2]}-${date2[1]}-${date2[0]}`;

                if (
                    templateDetail?.version ===
                    templateDetail?.latestPublishedVersion
                ) {
                    setDocInfo([
                        {
                            fileName:
                                lang === 'en'
                                    ? `${decodeHtmlString(
                                          templateDetail?.templateNameEn
                                      )}_${publishedDate}_TH`
                                    : `${decodeHtmlString(
                                          templateDetail?.templateNameTh
                                      )}_${publishedDate}_TH`,
                            templateKey: templateDetail?.templateKey,
                            lang: 'th', //"en", "th"
                            version: templateDetail?.latestPublishedVersion,
                            fileType: 'docx', //"docx", "pdf"
                            versionType: 'Published ', //"docx", "pdf"
                            logoId: templateDetail?.logoId,
                        },
                        {
                            fileName:
                                lang === 'en'
                                    ? `${decodeHtmlString(
                                          templateDetail?.templateNameEn
                                      )}_${publishedDate}_EN`
                                    : `${decodeHtmlString(
                                          templateDetail?.templateNameTh
                                      )}_${publishedDate}_EN`,
                            templateKey: templateDetail?.templateKey,
                            lang: 'en', //"en", "th"
                            version: templateDetail?.latestPublishedVersion,
                            fileType: 'docx', //"docx", "pdf"
                            versionType: 'Published ', //"docx", "pdf"
                            logoId: templateDetail?.logoId,
                        },
                        {
                            fileName:
                                lang === 'en'
                                    ? `${decodeHtmlString(
                                          templateDetail?.templateNameEn
                                      )}_${publishedDate}_TH`
                                    : `${decodeHtmlString(
                                          templateDetail?.templateNameTh
                                      )}_${publishedDate}_TH`,
                            templateKey: templateDetail?.templateKey,
                            lang: 'th', //"en", "th"
                            version: templateDetail?.latestPublishedVersion,
                            fileType: 'pdf', //"docx", "pdf"
                            versionType: 'Published ', //"docx", "pdf"
                            logoId: templateDetail?.logoId,
                        },
                        {
                            fileName:
                                lang === 'en'
                                    ? `${decodeHtmlString(
                                          templateDetail?.templateNameEn
                                      )}_${publishedDate}_EN`
                                    : `${decodeHtmlString(
                                          templateDetail?.templateNameTh
                                      )}_${publishedDate}_EN`,
                            templateKey: templateDetail?.templateKey,
                            lang: 'en', //"en", "th"
                            version: templateDetail?.latestPublishedVersion,
                            fileType: 'pdf', //"docx", "pdf"
                            versionType: 'Published ', //"docx", "pdf"
                            logoId: templateDetail?.logoId,
                        },
                    ]);
                } else {
                    setDocInfo([
                        {
                            fileName:
                                lang === 'en'
                                    ? `${decodeHtmlString(
                                          templateDetail?.templateNameEn
                                      )}_${updateDate}_TH`
                                    : `${decodeHtmlString(
                                          templateDetail?.templateNameTh
                                      )}_${updateDate}_TH`,
                            templateKey: templateDetail?.templateKey,
                            lang: 'th', //"en", "th"
                            version: templateDetail?.version,
                            fileType: 'docx', //"docx", "pdf"
                            versionType: 'Latest Version', //"docx", "pdf"
                            logoId: templateDetail?.logoId,
                        },
                        {
                            fileName:
                                lang === 'en'
                                    ? `${decodeHtmlString(
                                          templateDetail?.templateNameEn
                                      )}_${updateDate}_EN`
                                    : `${decodeHtmlString(
                                          templateDetail?.templateNameTh
                                      )}_${updateDate}_EN`,
                            templateKey: templateDetail?.templateKey,
                            lang: 'en', //"en", "th"
                            version: templateDetail?.version,
                            fileType: 'docx', //"docx", "pdf"
                            versionType: 'Latest Version', //"docx", "pdf"
                            logoId: templateDetail?.logoId,
                        },
                        {
                            fileName:
                                lang === 'en'
                                    ? `${decodeHtmlString(
                                          templateDetail?.templateNameEn
                                      )}_${updateDate}_TH`
                                    : `${decodeHtmlString(
                                          templateDetail?.templateNameTh
                                      )}_${updateDate}_TH`,
                            templateKey: templateDetail?.templateKey,
                            lang: 'th', //"en", "th"
                            version: templateDetail?.version,
                            fileType: 'pdf', //"docx", "pdf"
                            versionType: 'Latest Version', //"docx", "pdf"
                            logoId: templateDetail?.logoId,
                        },
                        {
                            fileName:
                                lang === 'en'
                                    ? `${decodeHtmlString(
                                          templateDetail?.templateNameEn
                                      )}_${updateDate}_EN`
                                    : `${decodeHtmlString(
                                          templateDetail?.templateNameTh
                                      )}_${updateDate}_EN`,
                            templateKey: templateDetail?.templateKey,
                            lang: 'en', //"en", "th"
                            version: templateDetail?.version,
                            fileType: 'pdf', //"docx", "pdf"
                            versionType: 'Latest Version', //"docx", "pdf"
                            logoId: templateDetail?.logoId,
                        },
                        {
                            fileName:
                                lang === 'en'
                                    ? `${decodeHtmlString(
                                          templateDetail?.templateNameEn
                                      )}_${publishedDate}_TH`
                                    : `${decodeHtmlString(
                                          templateDetail?.templateNameTh
                                      )}_${publishedDate}_TH`,
                            templateKey: templateDetail?.templateKey,
                            lang: 'th', //"en", "th"
                            version: templateDetail?.latestPublishedVersion,
                            fileType: 'docx', //"docx", "pdf"
                            versionType: 'Published ', //"docx", "pdf"
                            logoId: templateDetail?.logoId,
                            published: true,
                        },
                        {
                            fileName:
                                lang === 'en'
                                    ? `${decodeHtmlString(
                                          templateDetail?.templateNameEn
                                      )}_${publishedDate}_EN`
                                    : `${decodeHtmlString(
                                          templateDetail?.templateNameTh
                                      )}_${publishedDate}_EN`,
                            templateKey: templateDetail?.templateKey,
                            lang: 'en', //"en", "th"
                            version: templateDetail?.latestPublishedVersion,
                            fileType: 'docx', //"docx", "pdf"
                            versionType: 'Published ', //"docx", "pdf"
                            logoId: templateDetail?.logoId,
                            published: true,
                        },
                        {
                            fileName:
                                lang === 'en'
                                    ? `${decodeHtmlString(
                                          templateDetail?.templateNameEn
                                      )}_${publishedDate}_TH`
                                    : `${decodeHtmlString(
                                          templateDetail?.templateNameTh
                                      )}_${publishedDate}_TH`,
                            templateKey: templateDetail?.templateKey,
                            lang: 'th', //"en", "th"
                            version: templateDetail?.latestPublishedVersion,
                            fileType: 'pdf', //"docx", "pdf"
                            versionType: 'Published ', //"docx", "pdf"
                            logoId: templateDetail?.logoId,
                            published: true,
                        },
                        {
                            fileName:
                                lang === 'en'
                                    ? `${decodeHtmlString(
                                          templateDetail?.templateNameEn
                                      )}_${publishedDate}_EN`
                                    : `${decodeHtmlString(
                                          templateDetail?.templateNameTh
                                      )}_${publishedDate}_EN`,
                            templateKey: templateDetail?.templateKey,
                            lang: 'en', //"en", "th"
                            version: templateDetail?.latestPublishedVersion,
                            fileType: 'pdf', //"docx", "pdf"
                            versionType: 'Published ', //"docx", "pdf"
                            logoId: templateDetail?.logoId,
                            published: true,
                        },
                    ]);
                }
            }
        }
    }, [templateDetail, lang]);

    const getTagStatus_ = (type) => {
        switch (type) {
            case 'Latest Version':
                return (
                    <Tag className="rounded-xl text-[#1890FF] border-[#1890FF] bg-white -my-1 font-medium">
                        {i18n.language === 'en' ? type : type}
                    </Tag>
                );
            case 'Published':
                return (
                    <Tag className="rounded-xl text-[#4ACE8F] border-[#4ACE8F] bg-white -my-1 font-medium">
                        {i18n.language === 'en' ? type : type}
                    </Tag>
                );
            default:
                return (
                    <Tag className="rounded-xl text-[#4ACE8F] border-[#4ACE8F] bg-white -my-1 font-medium">
                        {i18n.language === 'en' ? type : type}
                    </Tag>
                );
        }
    };

    const columns = [
        {
            title: t('File name'),
            dataIndex: 'fileName',
            key: 'fileName',
            width: '60%',
            sorter: true,
            render: (value, row, index) => {
                return (
                    <div className="flex items-center">
                        <span className="px-2">
                            {row.fileType === 'pdf' ? IconPdf : IconDoc}
                        </span>
                        <span className="text-sm font-semibold">{`${row.fileName}.${row.fileType}`}</span>
                    </div>
                );
            },
        },
        {
            title: t('Version'),
            dataIndex: 'version',
            key: 'version',
            width: '30%',
            sorter: true,
            render: (value, row, index) => {
                return (
                    <>
                        <span className="text-sm font-semibold">
                            {row.version}
                        </span>
                        <span className="px-2">
                            {getTagStatus_(row.versionType)}
                        </span>
                    </>
                );
            },
        },
        {
            title: t('Action'),
            key: 'action',
            align: 'center',
            width: '10%',
            render: (text, record) => {
                let value = templateDetail;
                if (record.published) value = templateDetailPublish;
                return (
                    <span
                        className="flex items-center justify-center "
                        style={{ whiteSpace: 'nowrap' }}
                    >
                        <button
                            disabled={isAuditor}
                            key={text}
                            onClick={() => {
                                setKeys_(text);
                                downloadFile(
                                    value,
                                    record.lang,
                                    record.fileType,
                                    `${record.fileName}.${record.fileType}`,
                                    record.published
                                );
                            }}
                            className="bg-[#F3F6F9] disabled:opacity-50 disabled:cursor-not-allowed h-10 w-10 flex items-center justify-center rounded-lg text-purple text-lg cursor-pointer hover:border-[#7B67FB] hover:border hover:border-solid"
                        >
                            {loading_ && text === key ? (
                                <LoadingOutlined />
                            ) : (
                                <DownloadOutlined />
                            )}
                        </button>
                    </span>
                );
            },
        },
    ];

    const term = masterTerm?.find(
        (term) => term?.consentTxnGroupId === templateDetail?.consentTxnGroupId
    );

    const downloadFile = async (value, lang, fileType, fileName, published) => {
        try {
            let templateBody = '';
            let imgUrl = published ? logoPublish : logo;
            if (templateType === 'Consent') {
                templateBody =
                    lang === 'th'
                        ? htmlToStringTh(value, fileName, imgUrl)
                        : htmlToStringEn(value, fileName, imgUrl);
            }

            if (templateType === 'Term & Condition') {
                const _value = {
                    ...value,
                    purpose: lang === 'th' ? term?.purposeTh : term?.purposeEn,
                };
                templateBody =
                    lang === 'th'
                        ? htmlTermToStringTh(_value, fileName, imgUrl)
                        : htmlTermToStringEn(_value, fileName, imgUrl);
            }

            if (templateBody) {
                setLoading_(true);
                if (fileType === 'docx') {
                    let blob = new Blob([templateBody], { type: 'text/html' });
                    let url = URL.createObjectURL(blob);
                    window.open(url);
                    setLoading_(false);
                } else {
                    const payload = {
                        templateDesignId: value?.templateId,
                        lang, //"en", "th"
                        version: value?.version,
                        fileType, //"docx", "pdf"
                        templateBody,
                        imageTag: imgUrl
                            ? `<img height="60" src=${imgUrl} alt="logo" />`
                            : '',
                        logoId: value?.logoId,
                    };
                    const { data } = await TemplateDesignService.downloadFile(
                        payload
                    );
                    if (data.resultData) {
                        const newBlob = convertBase64toBlob(
                            data.resultData?.fileDoc,
                            documentType[fileType]
                        );
                        let link = document.createElement('a');
                        link.download = fileName;
                        link.href = URL.createObjectURL(newBlob);
                        link.click();
                        link.remove();
                    }
                    setLoading_(false);
                }
            }
        } catch (error) {
            notify({
                type: 'error',
                title: t('Fail'),
                description: t('Download failed'),
            });
            setLoading_(false);
            console.log(error);
        }
    };

    return (
        <div className="bg-white rounded-md shadow-sm w-full p-6">
            <span className="text-[20px] font-medium">Download file</span>

            <Spin spinning={!docInfo}>
                {docInfo?.length > 0 ? (
                    <div className="mt-6 mb-10">
                        <Table
                            className="inbox_table"
                            dataSource={docInfo || []}
                            columns={columns}
                            pagination={false}
                            scroll={{
                                y: 340,
                            }}
                        />
                    </div>
                ) : (
                    // <div className='bg-white rounded-md shadow-sm w-full p-6'>
                    <div className="text-center text-sm space-y-2 my-32">
                        <IconNoData />
                        <p className="text-[#65707A] text-[14px]">
                            {t('No Data')}
                        </p>
                        {/* </div> */}
                    </div>
                )}
            </Spin>
        </div>
    );
};

export default DownloadFile;

// const docList = [];

const IconPdf = (
    <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.64982 0H14.6738L21.4744 7.08846V20.8756C21.4744 22.6027 20.0771 24 18.3559 24H6.64982C4.92269 24 3.52539 22.6027 3.52539 20.8756V3.12443C3.52536 1.3973 4.92266 0 6.64982 0V0Z"
            fill="#E5252A"
        />
        <path
            opacity="0.302"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.668 0V7.03449H21.4746L14.668 0Z"
            fill="white"
        />
        <path
            d="M6.99805 17.9072V13.5234H8.86312C9.32489 13.5234 9.69072 13.6494 9.96658 13.9072C10.2424 14.1591 10.3804 14.501 10.3804 14.9267C10.3804 15.3525 10.2424 15.6944 9.96658 15.9462C9.69072 16.2041 9.32489 16.33 8.86312 16.33H8.11949V17.9072H6.99805ZM8.11949 15.3765H8.73719C8.90509 15.3765 9.03703 15.3405 9.127 15.2566C9.21694 15.1786 9.26494 15.0707 9.26494 14.9268C9.26494 14.7829 9.21697 14.6749 9.127 14.5969C9.03706 14.513 8.90512 14.477 8.73719 14.477H8.11949V15.3765ZM10.8421 17.9072V13.5234H12.3953C12.7012 13.5234 12.9891 13.5654 13.2589 13.6554C13.5288 13.7453 13.7747 13.8713 13.9905 14.0452C14.2064 14.2131 14.3803 14.441 14.5063 14.7288C14.6262 15.0167 14.6922 15.3465 14.6922 15.7183C14.6922 16.0842 14.6262 16.414 14.5063 16.7018C14.3803 16.9897 14.2064 17.2176 13.9905 17.3855C13.7746 17.5594 13.5288 17.6853 13.2589 17.7753C12.9891 17.8652 12.7012 17.9072 12.3953 17.9072H10.8421ZM11.9396 16.9537H12.2634C12.4373 16.9537 12.5992 16.9358 12.7492 16.8938C12.8931 16.8518 13.031 16.7858 13.163 16.6959C13.2889 16.6059 13.3908 16.48 13.4628 16.3121C13.5348 16.1442 13.5708 15.9462 13.5708 15.7183C13.5708 15.4845 13.5348 15.2866 13.4628 15.1187C13.3908 14.9508 13.2889 14.8248 13.163 14.7348C13.031 14.6449 12.8931 14.5789 12.7492 14.537C12.5992 14.495 12.4373 14.477 12.2634 14.477H11.9396V16.9537ZM15.2559 17.9072V13.5234H18.3744V14.477H16.3774V15.1786H17.9726V16.1261H16.3774V17.9072H15.2559Z"
            fill="white"
        />
    </svg>
);

const IconDoc = (
    <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6.64751 0H14.6777L21.4753 7.09195V20.8779C21.4753 22.6023 20.0776 24 18.3531 24H6.64751C4.92305 24 3.52539 22.6023 3.52539 20.8779V3.12212C3.52539 1.39769 4.92305 0 6.64751 0V0Z"
            fill="#0263D1"
        />
        <path
            opacity="0.302"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.668 0V7.0337H21.4752L14.668 0Z"
            fill="white"
        />
        <path
            d="M6.42383 17.1248V13.1517H7.83122C8.11269 13.1517 8.37478 13.1938 8.61743 13.2715C8.86008 13.3523 9.08008 13.4688 9.27746 13.6241C9.47481 13.7794 9.63013 13.9865 9.74336 14.2453C9.85659 14.5041 9.91484 14.8018 9.91484 15.1383C9.91484 15.4747 9.85659 15.7724 9.74336 16.0312C9.63013 16.29 9.47481 16.4971 9.27746 16.6524C9.08011 16.8077 8.86008 16.9242 8.61743 17.0051C8.37478 17.0827 8.11272 17.1248 7.83122 17.1248H6.42383ZM7.41709 16.261H7.7115C7.87004 16.261 8.01887 16.2415 8.1515 16.2059C8.28739 16.1671 8.41032 16.1057 8.52679 16.0248C8.64327 15.9439 8.73384 15.8274 8.79856 15.6753C8.86651 15.5265 8.89884 15.3453 8.89884 15.1383C8.89884 14.9312 8.86648 14.75 8.79856 14.598C8.73384 14.4491 8.64327 14.3327 8.52679 14.2518C8.41032 14.1677 8.28739 14.1094 8.1515 14.0706C8.01887 14.035 7.87004 14.0156 7.7115 14.0156H7.41709V16.261ZM12.3252 17.1701C11.7266 17.1701 11.2316 16.976 10.8401 16.591C10.4487 16.2059 10.2545 15.7206 10.2545 15.1383C10.2545 14.5559 10.4487 14.0706 10.8401 13.6856C11.2316 13.3006 11.7266 13.1065 12.3252 13.1065C12.914 13.1065 13.4025 13.3006 13.794 13.6856C14.1823 14.0707 14.3764 14.556 14.3764 15.1383C14.3764 15.7206 14.1823 16.206 13.794 16.591C13.4025 16.976 12.914 17.1701 12.3252 17.1701ZM11.5616 15.9762C11.759 16.1962 12.0113 16.3063 12.3187 16.3063C12.626 16.3063 12.8752 16.1962 13.0725 15.9762C13.2699 15.753 13.3669 15.4747 13.3669 15.1383C13.3669 14.8018 13.2699 14.5235 13.0725 14.3003C12.8752 14.0803 12.626 13.9703 12.3187 13.9703C12.0113 13.9703 11.759 14.0803 11.5616 14.3003C11.3643 14.5235 11.264 14.8018 11.264 15.1383C11.264 15.4747 11.3643 15.753 11.5616 15.9762ZM16.7382 17.1701C16.1591 17.1701 15.677 16.9889 15.2952 16.633C14.9102 16.2739 14.7194 15.7756 14.7194 15.1383C14.7194 14.5041 14.9135 14.0059 15.3017 13.6468C15.6932 13.2876 16.1688 13.1064 16.7382 13.1064C17.2527 13.1064 17.6732 13.2326 18.0065 13.4882C18.3365 13.7406 18.5274 14.0771 18.5759 14.4976L17.573 14.7015C17.5309 14.4815 17.4306 14.3035 17.2753 14.1709C17.12 14.0382 16.9388 13.9703 16.7318 13.9703C16.447 13.9703 16.2108 14.0706 16.02 14.2744C15.8291 14.4815 15.732 14.7662 15.732 15.1382C15.732 15.5103 15.8291 15.795 16.0167 15.9989C16.2076 16.2059 16.4438 16.3062 16.7317 16.3062C16.9388 16.3062 17.1167 16.248 17.2623 16.1315C17.4079 16.0151 17.4985 15.8598 17.5373 15.6656L18.563 15.8986C18.4691 16.2998 18.262 16.6104 17.9385 16.8336C17.6182 17.0569 17.2171 17.1701 16.7382 17.1701V17.1701Z"
            fill="white"
        />
    </svg>
);
